import auth from "../middleware/auth";

export default [
    {
        path: "/microphone",
        name: "microphone.home",
        component: () => {
            return import(
                 "@/projects/capture/App.vue"
            );
        },
        middleware: [auth()],
        meta: {
            title: "capture.microphoneview.title"
        },
        props: {
            type: "microphone"
        }
    },
    {
        path: "/camera",
        name: "camera.home",
        component: () => {
            return import(
                 "@/projects/capture/App.vue"
            );
        },
        middleware: [auth()],
        meta: {
            title: "capture.photoview.title"
        },
        props: {
            type: "photo"
        }
    },
    {
        path: "/video",
        name: "video.home",
        component: () => {
            return import(
                 "@/projects/capture/App.vue"
            );
        },
        middleware: [auth()],
        meta: {
            title: "capture.videoview.title"
        },
        props: {
            type: "video"
        }
    }
];
